module.exports = __webpack_public_path__ + "static/media/advantages3.0026711c.png";